import i18n from '../../../i18n'

const daysInAdvanceOption = value => ({
  value,
  get label() {
    return i18n.t('events.seriesFlow.notificationOptions.daysInAdvance', { count: value })
  },
})

const doNotSendOption = {
  value: '',
  get label() {
    return i18n.t('events.seriesFlow.notificationOptions.doNotSend')
  },
}

const FIVE_DAYS_IN_ADVANCE = [5, 4, 3, 2, 1].map(daysInAdvanceOption)

export const NOTIFICATION_OPTIONS_FIVE_DAYS = [
  doNotSendOption,
  ...FIVE_DAYS_IN_ADVANCE,
]

export const NOTIFICATION_OPTIONS_TEN_DAYS = [
  doNotSendOption,
  ...[10, 9, 8, 7, 6].map(daysInAdvanceOption),
  ...FIVE_DAYS_IN_ADVANCE,
]
